// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3nRm4","row":"styles_row__RAtxR","columned":"styles_columned__uXpVG","bodyText":"styles_bodyText__UqJyY","linkText":"styles_linkText__TbzLF"};